module.exports = __webpack_public_path__ + "static/media/tennet-kaartnl-250520.aaf6d996.png";